import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_TOKEN_LIMITS: MijnRoute = {
    path: 'limieten-beheren',
    navigationEvent: 'toLimieten',
    regex: /^\/zelf-regelen\/limieten-beheren$/,
    webcomponent: 'mijn-tokens-limieten-webcomponent'
};
